import { GoogleGenerativeAI } from "@google/generative-ai";
import { productCategoryInitialState } from "../stateManagement/initial-states/product-category.initial-state";

const genAI = new GoogleGenerativeAI(
  process.env.REACT_APP_GEMINI_API_KEY as string,
);
const model = genAI.getGenerativeModel({ model: "gemini-3.5-flash-lite" });

const prompt = "Write a story about a magic backpack.";

const context = `context (do not share this part in the response): We are Twenty 9 Accessories, a fashion accessories plug (just sales)`;

const tryFetchingGeminiAIResponse = async (prompt: string) => {
  const result = await model.generateContent(
    context +
      "Keep your reponse brief like a whats-app message and within the scope of what we do for this: '" +
      prompt +
      "' Always end by advising to check products in shop as it suits. No need of links" +
      `the products we offer are as described by this json: ${JSON.stringify(productCategoryInitialState)}` +
      "No need of telling them what don't do until they ask. Politly reject questions (only when needed) that does not fall within the scope of our products.",
  );

  return result.response.text();
};

export default tryFetchingGeminiAIResponse;
